import usePut from "../usePut";

const useUpdateAccount = (callbacks = {}) => {
  const { onSuccess, onError, onSettled } = callbacks;
  
  const { handleAuth, isLoading: isUpdating } = usePut({
    url: 'update_profile',
    refreshUrl: 'get_profile',
    onSuccess,
    onError,
    onSettled
  });

  const { handleAuth: handleRemoveImage, isLoading: isRemoving } = usePut({
    url: 'remove_profile_image',
    refreshUrl: 'get_profile',  
    onSuccess: (data) => {
      onSuccess?.(data, true); 
    },
    onError,
    onSettled
  });

  const updateAccount = (data) => {
    return handleAuth.mutate(data);
  };
  
  const removeProfileImage = (imageId) => {
    return handleRemoveImage.mutate({
      user_profile_image_id: imageId
    });
  };
  
  return { 
    updateAccount, 
    removeProfileImage, 
    isUpdating, 
    isRemoving 
  };
};

export default useUpdateAccount;
